import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'
export interface FileInfo {
  key: string
}
interface CheckUploadRes {
  Header: object | null,
  Method: string,
  URL: string,
  Values: object,
  key: string,
}
interface CheckUploadParams {
  file_name: string,
  file_size: number
}

@Injectable()
export class FileWhitelistService {
  constructor(private http: Http) { }
  checkUpload(params: CheckUploadParams) {
    return this.http.post<CheckUploadRes>('/sign-extract/check-upload', params)
  }
  saveFileInfo(data: FileInfo) {
    return this.http.post<{ task_id: string }>('/sign-extract/save-file-info', data)
  }
  getFileTaskResult(task_id: string) {
    return this.http.post('/sign-extract/query-task-result', { task_id })
  }
}
